<template>
  <div class="home-container">
    <v-container fill-height class="justify-center">
      <div class="d-flex flex-column fill-width">
        <v-row justify="center">
          <v-col cols="10" md="6" lg="4" xl="3">
            <v-card
              class="pa-8"
              height="100%"
              width="100%"
              flat
              :disabled="disableCard"
              :elevation="3"
              @click="handleCaptcha('new')"
            >
              <div
                class="d-flex flex-column fill-height justify-center align-center"
              >
                <div class="d-flex align-center justify-center mb-2">
                  <v-img
                    :src="require('@/assets/attendance.png')"
                    max-width="15rem"
                    contain
                  />
                </div>

                <div class="text-h6 font-weight-light text-center">
                  Iniciar Novo Atendimento
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col v-if="requester.name" cols="10" md="6" lg="4" xl="3">
            <v-card
              class="pa-8"
              :disabled="disableCard"
              height="100%"
              width="100%"
              :elevation="3"
              flat
              @click="handleCaptcha('fast')"
            >
              <div class="d-flex flex-column">
                <div class="d-flex align-center justify-center mb-2">
                  <v-img
                    :src="require('@/assets/guy.png')"
                    max-width="15rem"
                    contain
                  />
                </div>

                <v-spacer />

                <div class="text-h6 font-weight-light text-center">
                  Iniciar Como
                </div>

                <div class="text-center">
                  <div class="font-weight-bold text-body-2">
                    <v-tooltip
                      :disabled="
                        requester?.name?.trim().split(/\s+/).length === 1
                      "
                      bottom
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ formatName(requester.name) }}
                        </span>
                      </template>

                      <div>
                        {{ requester.name }}
                      </div>
                    </v-tooltip>
                    <span v-if="requester.cpf"> | {{ requester.cpf }} </span
                    ><span v-if="requester.phone">
                      | {{ requester.phone }} </span
                    ><span v-if="requester.email">
                      | {{ requester.email }}
                    </span>
                  </div>

                  <section
                    v-if="deskInfo"
                    class="d-flex flex-column justify-center align-center mt-3"
                  >
                    <v-tooltip v-if="deskInfo?.comarca?.name" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="mb-1" small>
                          <span class="ellipsis text-caption">
                            {{ deskInfo.comarca.name }}
                          </span>
                        </v-chip>
                      </template>

                      <div>
                        {{ deskInfo.comarca.name }}
                      </div>
                    </v-tooltip>

                    <v-tooltip v-if="deskInfo?.vara?.name" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="mb-1" small>
                          <span class="ellipsis text-caption">
                            {{ deskInfo.vara.name }}
                          </span>
                        </v-chip>
                      </template>

                      <div>
                        {{ deskInfo.vara.name }}
                      </div>
                    </v-tooltip>

                    <v-tooltip v-if="deskInfo?.name" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="mb-1" small>
                          <span class="ellipsis text-caption">
                            {{ deskInfo.name }}
                          </span>
                        </v-chip>
                      </template>

                      <div>
                        {{ deskInfo.name }}
                      </div>
                    </v-tooltip>
                  </section>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="requester.name" class="mt-2" justify="center" no-gutters>
          <v-col cols="10" md="6" lg="4" xl="3"> </v-col>

          <v-col cols="10" md="6" lg="4" xl="3">
            <div class="d-flex align-center justify-center">
              <v-btn class="text-none" text @click="clearRequester()"
                >Limpar Dados</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </div>

      <v-row justify="center">
        <v-col cols="12" md="8" xl="7">
          <div class="text-body-1 font-weight-light text-center">
            Use a opção acima para iniciar um novo atendimento. Este canal foi
            criado para facilitar o contato direto entre a comunidade escolar e
            a Secretaria Municipal da Educação de Ribeirão Preto.
          </div>
        </v-col>
      </v-row>
    </v-container>

    <LoadingOverlay :loading="loading.overlay" />

    <v-dialog v-model="captchaDialog" max-width="19.75rem" persistent>
      <v-card v-if="captchaDialog" class="pa-2">
        <vue-recaptcha
          ref="recaptcha"
          :sitekey="_siteKey"
          @verify="onVerify"
          @expired="onExpired"
        ></vue-recaptcha>
      </v-card>
    </v-dialog>

    <SelectorDialog
      v-model="selectorModal"
      :enabledToClose="true"
      @submit="selectorSubmit"
    />

    <BannerDialog v-if="!loading.content" />

    <LoadingOverlay :loading="loading.overlay" />

    <df-messenger
      access-token-name="df_access_token"
      location="us-central1"
      project-id="balcao-virtual-default"
      agent-id="da6881a9-5bf7-4981-922d-a74edfb10a83"
      language-code="pt-br"
      max-query-length="-1"
    >
      <df-messenger-chat-bubble
        chat-title="Balcão Virtual"
        chat-icon="https://imgur.com/a/lktm8zC"
      >
      </df-messenger-chat-bubble>
    </df-messenger>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { handleAlert, formatDocument, showError } from "@/utils";
import { VueRecaptcha } from "vue-recaptcha";
import { updateAttendance } from "@/services/attendance";
import { getCounter, getCounterStatus } from "@/services/counters";
import LoadingOverlay from "@/components/loadingOverlay/LoadingOverlay.vue";
import SelectorDialog from "@/components/selectorDialog/SelectorDialog";
import BannerDialog from "./partials/bannerDialog/BannerDialog.vue";

export default {
  name: "Home",

  components: {
    LoadingOverlay,
    VueRecaptcha,
    SelectorDialog,
    BannerDialog,
  },

  data() {
    return {
      loading: {
        content: true,
        overlay: false,
      },
      type: "",
      selectorModal: false,
      selectedOptions: {},
      disableCard: false,
      validCaptcha: false,
      captchaDialog: false,
      deskInfo: null,
    };
  },

  computed: {
    ...mapState("socket", ["attendance"]),
    ...mapState(["preSelection", "requester"]),

    _siteKey() {
      return process.env.VUE_APP_GCAPTCHA_PUBLIC_KEY;
    },
  },

  mounted() {
    this.handleQuerys();
    this.clearHistoryChat();
  },

  methods: {
    ...mapActions("socket", [
      "createNewAttendance",
      "setAttendance",
      "requestAttendance",
      "setMessages",
      "setShouldClearStorage",
      "setInQueue",
    ]),

    ...mapActions(["setPreSelection", "setRequester"]),

    handleCaptcha(type) {
      this.type = type || "new";

      this.captchaDialog = true;
      // this.handleStartChat();
    },

    async handleStartChat(chatPath = "/chat-cx") {
      await this.createNewAttendance({
        callback: (error, data) => {
          if (error)
            throw new Error("Falha ao tentar conectar ao socket. error");

          this.setShouldClearStorage(true);
          this.setMessages([]);
          this.setAttendance(data);

          this.$router.push(chatPath).catch(() => {});
        },
      });
    },

    clearHistoryChat() {
      const dfMessenger = document.querySelector("df-messenger");

      if (dfMessenger) {
        if (dfMessenger && typeof dfMessenger.clearStorage === "function") {
          dfMessenger.clearStorage();
          this.setShouldClearStorage(false);
        }
      }
    },

    onVerify(response) {
      this.captchaDialog = false;

      if (!response) return;

      this.validCaptcha = true;

      if (this.type === "fast") {
        this.handleFastAttendance();
        return;
      }

      this.handleStartChat();
    },

    onExpired() {
      this.validCaptcha = false;
      this.captchaDialog = false;
    },

    async handleQuerys() {
      let query = {};

      if (Object.keys(this.preSelection)) query = this.preSelection;
      if (Object.keys(this.$route.query).length) query = this.$route.query;

      if (!query || !Object.keys(query).length) {
        this.loading.content = false;
        return;
      }

      this.loading.overlay = true;

      const payload = {
        ...(query.deskID && { deskID: query.deskID }),
        ...(query.subgroupID && { subgroupID: query.subgroupID }),
        ...(query.groupID && { groupID: query.groupID }),
      };

      await this.setPreSelection(payload);

      if (query.deskID) {
        this.getCounter(query.deskID);
      }

      const hasFullPreSelection =
        payload.deskID && payload.subgroupID && payload.groupID;

      if (hasFullPreSelection || !Object.keys(this.requester).length)
        await this.handleStartChat();

      this.loading.overlay = false;
      this.loading.content = false;
    },

    async handleFastAttendance() {
      if (
        this.preSelection?.deskID &&
        this.preSelection?.subgroupID &&
        this.preSelection?.groupID
      ) {
        this.loading.overlay = true;
        this.selectedOptions = structuredClone(this.preSelection);

        this.createFastAttendance();
        return;
      }

      this.selectorModal = true;
    },

    async getCounter(deskID) {
      if (!deskID) return;

      try {
        const { data } = await getCounter(deskID);
        this.deskInfo = data;
      } catch (error) {
        this.handleAlert(error?.data?.message || error?.message, "error");
      }
    },

    async isDeskInWorkingHours(deskID) {
      try {
        const { data } = await getCounterStatus(deskID);

        if (data.isAvailable) return true;

        this.handleAlert(
          "Não há horário de atendimento disponível neste balcão no momento. Por favor, tente novamente dentro do horário de funcionamento.",
          "warning",
          true
        );
        return false;
      } catch (error) {
        this.showError(error);
        return false;
      }
    },

    async createFastAttendance() {
      if (!(await this.isDeskInWorkingHours(this.selectedOptions.deskID))) {
        this.loading.overlay = false;
        return;
      }

      await this.createNewAttendance({
        callback: async (error, data) => {
          if (error)
            throw new Error("Falha ao tentar conectar ao socket. error");

          this.setShouldClearStorage(true);
          this.setMessages([]);
          this.setAttendance(data);

          await updateAttendance(this.attendance._id, {
            requester: {
              name: this.requester.name,
              ...(this.requester.cpf && {
                cpf: this.requester.cpf,
              }),
              ...(this.requester.email && {
                email: this.requester.email,
              }),
              ...(this.requester.phone && {
                phone: this.requester.phone,
              }),
            },
            attendanceFormat: "chat",
            comarcaID: this.selectedOptions.groupID,
            varaID: this.selectedOptions.subgroupID,
            deskID: this.selectedOptions.deskID,
          });

          await this.requestAttendance({
            data: {
              protocol: data.protocol,
              deskID: this.selectedOptions.deskID,
            },
            callback: (error, data) => {
              if (error) {
                throw new Error(
                  "Falha ao tentar solicitar atendimento. Tente novamente"
                );
              }

              // Update Attendance on Store
              this.setAttendance(data);
              this.setInQueue(true);
              this.$router.push({ path: "/queue" }).catch(() => {});
            },
          });
        },
      });
    },

    selectorSubmit(event) {
      this.loading.overlay = true;

      this.selectedOptions = {
        groupID: event.groups._id,
        subgroupID: event.subgroups._id,
        deskID: event.desks._id,
      };

      this.createFastAttendance();
    },

    clearRequester() {
      this.setRequester({});
    },

    formatName(name) {
      const parts = name.trim().split(/\s+/);

      if (parts.length >= 2) {
        return `${parts[0]} ${parts[1]}`;
      } else {
        return parts[0] || "";
      }
    },

    showError,

    handleAlert,

    formatDocument,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
